import React from 'react';
import HomeSection3 from '../../HomeSection3';
import './Terms.css'

import {
    sectionTwoObj,
} from './Data';

import '../Footer/Footer.css';

const Terms2 = ( lightBg ) => {
    return (
        <div>
            <HomeSection3 {...sectionTwoObj}/>

            <div className={lightBg ? 'terms__home-section' : 'terms__home-section darkBg'}>
                <div className="container">
                    <p className="terms">
                        <br/><br/>
                        <b>Terms & Conditions</b>
                        <br/><br/>
                        Thank you for accessing/shopping at <a href="https://www.shenzuspending.com">https://www.shenzuspending.com</a>. 
                        This site is owned by Shenzu Spending Private Limited (hereinafter referred to as “shenzuspending.com”). 
                        By accessing and shopping on this site, you indicate your unconditional acceptance of these terms & conditions.
                        <br/><br/>
                        We reserve the right, in our sole discretion, to update or revise these terms & conditions. Continued use of 
                        the site following the posting of any changes to the ‘terms & conditions’ constitutes your acceptance of those changes.
                        <br/><br/>
                        At shenzuspending.com, we strive to create a safe and secure environment where you can explore and shop for your 
                        favorite products and services. All products and information displayed on shenzuspending.com constitute an invitation 
                        to offer. shenzuspending.com reserves the right to accept or reject your offer. Your order for purchase constitutes 
                        your offer, which shall be subject to the terms and conditions listed below.
                        <br/><br/>
                        <b>1. Eligibility to Use Our Site</b><br/>
                        Use of the Site is available only to persons who can legally enter into contracts under applicable laws. Persons who 
                        are "incompetent to contract", within the meaning of the Indian Contract Act, 1872 (including un-discharged insolvents, etc.) 
                        are not eligible to use the Site. shenzuspending.com reserves the right to terminate your access if it discovers that you are under 18 years of age or otherwise ineligible under the Indian Contract Act, 1872.
                        <br/><br/>
                        <b>2. Membership</b><br/>
                        It is not essential to have an account to shop with shenzuspending.com; you may shop as a guest. However, if you register, 
                        you agree to provide true, accurate, current, and complete information about yourself as prompted by the site’s registration form.
                        Registration where prohibited under any law shall be void. shenzuspending.com reserves the right to revoke or terminate your 
                        registration for any reason at any time without notice.
                        <br/><br/>
                        <b>3. Electronic Communications</b><br/>
                        When you use the Site, send emails, or provide information to us electronically, you consent to receive communications from us electronically. 
                        We may communicate with you via email, SMS, or website notifications as required.
                        <br/><br/>
                        <b>4. Reviews, Feedback, and Submissions</b><br/>
                        All reviews, comments, feedback, suggestions, ideas, and other submissions disclosed, submitted, or offered to shenzuspending.com in connection 
                        with your use of this Site (collectively referred to as “Comments”) shall remain the property of shenzuspending.com. Such submissions constitute 
                        an assignment to shenzuspending.com of all worldwide rights, titles, and interests in copyrights and intellectual property rights in the Comments. 
                        We may use, reproduce, disclose, modify, adapt, publish, or distribute any Comments for any purpose without restriction or compensation.
                        <br/><br/>
                        You agree that your Comments will not violate any third-party rights (including copyright, trademark, privacy, or other personal rights) 
                        and will not include unlawful, abusive, obscene, or harmful content. You further agree not to use a false email address, impersonate another person, 
                        or mislead the origin of your Comments. You remain solely responsible for the content of your submissions and agree to indemnify shenzuspending.com 
                        against claims resulting from such Comments.
                        <br/><br/>
                        <b>5. Accuracy of Content & Product Information</b><br/>
                        While shenzuspending.com strives to provide accurate product and pricing information, typographical or technical errors may occur. 
                        In the event a product is listed at an incorrect price or with incorrect information: shenzuspending.com reserves the right, 
                        at its sole discretion, to modify the price or product information; or to refuse/cancel any orders placed for that product, unless 
                        the product has already been dispatched.
                        <br/><br/><br/>

                        
                        <br/><br/>
                        Last Updated: 25-09-2025
                        <br/><br/>
                        
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Terms2;
